<template>
  <div>

    <h6>Permissões do Usuário {{isEditing}}</h6>
    <b-form-group label="Selecione as Permissões">
      <b-form-checkbox-group
        v-model="selectedPermissions"
        :options="permissions"
        value-field="id"
        text-field="name"
        stacked
      />
    </b-form-group>
    <!-- <b-button variant="success" :disabled="loading || !selectedPermissions.length" @click="assignPermissions">
      {{ loading ? 'Atribuindo...' : 'Atribuir Permissões' }}
    </b-button> -->

    <b-button
  variant="success"
  :disabled="loading || !selectedPermissions.length"
  @click="assignPermissions"
>
  {{ loading ? 'Atribuindo...' : isEditing ? 'Atribuir/Remover Função' : 'Atribuir Permissões' }}
</b-button>
  </div>
</template>

<script>
  import ApiService from '@/common/api.service'

  export default {
    name: 'UserPermissions',
    props: {
      userId: {
        type: [Number, String],
        required: true,
      },
      companyId: {
        type: [Number, String],
        required: true,
      },
      isEditing: { type: Boolean, default: false } // nova prop
    },
    data() {
      return {
        permissions: [], // Lista de permissões do backend
        selectedPermissions: [], // Permissões selecionadas
        loading: false,
      }
    },
    mounted() {
      this.fetchPermissions().then(() => {
        this.fetchUserPermissions()
      })
    },

    methods: {
      async fetchPermissions() {
        try {
          const response = await ApiService.get('contract/permissions')
          this.permissions = response.data
        } catch (err) {
          console.error('Erro ao buscar permissões:', err)
          this.$bvToast.toast('Erro ao carregar permissões', {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          })
        }
      },
      async fetchUserPermissions() {
        try {
          const response = await ApiService.get(`contract/user/${this.userId}/permissions`, {
            params: { team_id: this.companyId },
          })
          this.selectedPermissions = response.data.map((p) => p.id) // Supondo que a resposta é uma lista de permissões com 'id'
        } catch (err) {
          console.error('Erro ao buscar permissões do usuário:', err)
          this.$bvToast.toast('Erro ao carregar permissões do usuário', {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          })
        }
      },

      async assignPermissions() {
        this.loading = true
        try {
          await ApiService.post('contract/user/permissions', {
            user_id: this.userId,
            permissions: this.selectedPermissions,
            team_id: this.companyId,
          })
          this.$bvToast.toast('Permissões atribuídas com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
          })
          this.$emit('permissions-assigned') // Emite evento para o componente pai
        } catch (err) {
          console.error('Erro ao atribuir permissões:', err.response?.data || err)
          this.$bvToast.toast(err.response?.data?.message || 'Falha ao atribuir permissões', {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          })
        } finally {
          this.loading = false,
          this.$emit('permissions-updated') 
        }
      },
    },
    
  }
</script>

<style scoped>
  div {
    margin-top: 20px;
  }
</style>
